import { render, staticRenderFns } from "./distribution-chart-inspection.vue?vue&type=template&id=bba74f30&scoped=true"
import script from "./distribution-chart-inspection.vue?vue&type=script&lang=js"
export * from "./distribution-chart-inspection.vue?vue&type=script&lang=js"
import style0 from "./distribution-chart-inspection.vue?vue&type=style&index=0&id=bba74f30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba74f30",
  null
  
)

export default component.exports